import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '@codex/icons';

const Container = styled.span`
  background-color: #f2f2f2;
  padding: 0 0 10px 0;
  display: block;
`;

const WhiteRectangle = styled.span`
  background-color: #fff;
  padding: 10px;
  display: block;
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    padding: 5px;
  }
`;

const GreenRectangle = styled.span`
  border-radius: 3px;
  border: solid 1px #cccccc;
  background-color: #f0f6eb;
  padding: 16px 20px 20px 20px;
  display: flex;
  font-size: 14px;
  font-family: Helvetica;
  line-height: 1.43;
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    padding: 7px 10px 10px 10px;
    font-size: 13px;
    line-height: 1.38;
  }
`;

const IconContainer = styled.span`
  padding: 4px 0;
`;

const StyledIcon = styled(Icon)`
  margin-right: 10px;
  width: 23px;
  height: 21px;
`;

const StyledIconDelivery = styled(Icon)`
    margin-right: 10px;
    width: 33px;
    height: 21px;
    margin-top: -4px;
`;

const CollectionFrom = ({ label, place, delivery }) => {
  if (label && place) {
    return (
      <Container>
        <WhiteRectangle>
          <GreenRectangle>
            <IconContainer><StyledIcon icon={'Store'} /></IconContainer>
            <span>
              <strong>{label}</strong>
              {' '}
              {place}
            </span>
          </GreenRectangle>
        </WhiteRectangle>
      </Container>
    );
  } if (label && delivery) {
    return (
      <Container>
        <WhiteRectangle>
          <GreenRectangle>
            <IconContainer><StyledIconDelivery icon={'Delivery'} /></IconContainer>
            <span><strong>{label}</strong></span>
          </GreenRectangle>
        </WhiteRectangle>
      </Container>
    );
  }
  return null;
};

CollectionFrom.propTypes = {
  label: PropTypes.string,
  place: PropTypes.string,
  delivery: PropTypes.bool
};

CollectionFrom.defaultProps = {
  label: null,
  place: null,
  delivery: false
};

export default CollectionFrom;
